module.exports = __webpack_public_path__ + "img/23_76.55bfc376.png";